import React, { useState } from 'react'
import Button from '../../Components/Button'
import styles from './Styles/DashboardHome.module.css'
import {BiChevronLeft, BiChevronRight} from "react-icons/bi"
import {HiCheck, HiUsers} from "react-icons/hi"
import {BsDot} from "react-icons/bs"
import {BiPlus, BiMinus} from "react-icons/bi"
import {MdOutlineCampaign} from "react-icons/md"
import { useNavigate } from 'react-router-dom'
import CustomDropdown from '../../Components/CustomDropdown'
import { FiTrendingDown, FiTrendingUp } from 'react-icons/fi'
import { Bar } from 'react-chartjs-2';

export default function DashboardHome() {
  return (
    <div className={styles.container}>
      <header>
        <p>Last Year</p>

        <div className={styles.dropdownContainer}>
        <CustomDropdown value="Last Year" options={['one','two']} />
        </div>
      </header>


      <div className={styles.headerCards}>
        <div className={styles.card}>
          <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:10}}>
            <div style={{backgroundColor:'#DAEEFF'}} className={styles.cardIcon}>
            <HiUsers color="#299EFE" size={20} />
            </div>
            <h2>New Leads</h2>
          </div>

          <div className={`${styles.trending} ${styles.up}`}>
            <h1>12</h1>
            <div>
            <FiTrendingUp />
            <p>+11 %</p>
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:10}}>
            <div style={{backgroundColor:'#F5E8DC'}} className={styles.cardIcon}>
            <HiUsers color="#D17E4F" size={20} />
            </div>
            <h2>Active Leads</h2>
          </div>

          <div className={`${styles.trending} ${styles.up}`}>
            <h1>3</h1>
            <div>
            <FiTrendingUp />
            <p>+11 %</p>
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:10}}>
            <div style={{backgroundColor:'#F5E8DC'}} className={styles.cardIcon}>
            <HiUsers color="#D17E4F" size={20} />
            </div>
            <h2>Converted Leads</h2>
          </div>

          <div className={`${styles.trending} ${styles.down}`}>
            <h1>1</h1>
            <div>
            <FiTrendingUp />
            <p>-10 %</p>
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:10}}>
            <div style={{backgroundColor:'#F5E8DC'}} className={styles.cardIcon}>
            <HiUsers color="#D17E4F" size={20} />
            </div>
            <h2>Earnings</h2>
          </div>

          <div>
            <h1>₹1.67 L</h1>
          </div>
        </div>
      </div>


      <main>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <h2>Finances</h2>
            <div style={{width:130}}>
            <CustomDropdown value="Last 7 Days" options={['one']} />
            </div>
          </div>

          <div className={styles.tableContainer}>
          <table cellPadding={0} cellSpacing={0} className={styles.table}>
            <thead>
              <tr>
                <th style={{width:100}}>Lead</th>
                <th>Date</th>
                <th>Project</th>
                <th>Description</th>
                <th>Content</th>
                <th>Content</th>
              </tr>
            </thead>
            <tbody>
              {Array(8).fill('').map(i => {
                return <tr>
                <td style={{width:100}} className={styles.leadId}>45216</td>
                <td>Nov 23, 2022</td>
                <td>Kalra Furniture</td>
                <td>Milestone 1 Completed</td>
                <td>content</td>
                <td>content</td>
              </tr>
              })}
            </tbody>
          </table>
          </div>
        </div>


        <div className={styles.card}>
        <div className={styles.cardHeader}>
            <h2>Leads Addition</h2>
            <div style={{width:130}}>
            <CustomDropdown value="Last 7 Days" options={['one']} />
            </div>
          </div>
          
        </div>
      </main>
    </div>
  )
}
